/**
 * Экспорт всех триггеров и фабрики
 */

// Типы
export type {
    RegisteredTrigger, TrackedTrigger,
    TrackTriggerCallback, TriggerContext,
    TriggerFunction, TriggerOptions, TriggerRegistry
} from './types'

// Фабрика
export { TriggerFactory } from './factory'

// Все триггеры
export {

    // Deprecated v4.x API
    afterLastShowAnyTrigger,
    afterLastShowOwnTrigger,
    afterLastShowTrigger,
    afterPageLoadTrigger, cooldownTrigger, eventTrigger, idleTrigger, limitSessionTrigger,
    // v5.0 API
    limitTrigger, mainPageTrigger, maxShowsOwnTrigger, notBlockedOwnTrigger, onCallbackTrigger, onEventTrigger, onIdleTrigger,
    onMainPageTrigger,
    onUrlTrigger, pageLoadedTrigger, showLessOwnTrigger, urlTrigger, waitForTrigger, waitTrigger, whenTrigger
} from './core-triggers'

// Создаем дефолтную фабрику с зарегистрированными триггерами
import {
    afterLastShowAnyTrigger,
    afterLastShowOwnTrigger,
    afterLastShowTrigger,
    afterPageLoadTrigger,
    cooldownTrigger,
    eventTrigger,
    idleTrigger,
    limitSessionTrigger,
    limitTrigger,
    mainPageTrigger,
    maxShowsOwnTrigger,
    notBlockedOwnTrigger,
    onCallbackTrigger,
    onEventTrigger,
    onIdleTrigger,
    onMainPageTrigger,
    onUrlTrigger,
    pageLoadedTrigger,
    showLessOwnTrigger,
    urlTrigger,
    waitForTrigger,
    waitTrigger,
    whenTrigger
} from './core-triggers'
import { TriggerFactory } from './factory'

/**
 * Дефолтная фабрика триггеров с предустановленными триггерами
 */
export const defaultTriggerFactory = new TriggerFactory()

// Регистрируем все базовые триггеры
defaultTriggerFactory.registerTriggers([
  // v5.0 API
  limitTrigger,
  limitSessionTrigger,
  waitTrigger,
  waitForTrigger,
  cooldownTrigger,
  pageLoadedTrigger,
  idleTrigger,
  mainPageTrigger,
  urlTrigger,
  eventTrigger,
  whenTrigger,
  
  // Deprecated v4.x API (для обратной совместимости)
  afterLastShowAnyTrigger,
  afterLastShowOwnTrigger,
  afterLastShowTrigger,
  afterPageLoadTrigger,
  onIdleTrigger,
  onMainPageTrigger,
  onUrlTrigger,
  onEventTrigger,
  onCallbackTrigger,
  maxShowsOwnTrigger,
  showLessOwnTrigger,
  notBlockedOwnTrigger
])
